import { render } from "./PostCardFooter.vue?vue&type=template&id=cee71c5e&ts=true"
import script from "./PostCardFooter.vue?vue&type=script&lang=ts"
export * from "./PostCardFooter.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__